import { useQuery } from "@tanstack/react-query";
import { gateway } from "../../../../../gateway";
import { decodeToken } from "../../../../../utils";

export const useInvitateSignUp = (uid) => {
  const invitationQuery = useQuery({
    queryKey: ["invitation-signup", uid],
    queryFn: async () => {
      if (!uid) throw new Error("Invitation uid not provided");

      const { data } = await gateway.get(`/invitations/validate/${uid}`);
      return data;
    },
    enabled: !!uid,
    retry: 1,
    staleTime: 1000 * 60 * 5,
  });

  const largeToken = invitationQuery?.data?.data;
  const userInvitationInfo = decodeToken(largeToken);

  return {
    // Data
    userInvitationInfo,
  };
};
